export default "__VITE_ASSET__BEwqAQnt__"